import React, { useState } from 'react';
import { WEBApi } from '../API/WEBApi';
import styles from './Login.module.css';

import { IoEyeSharp } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';


const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');

    try {
      setIsLoading(true);
      const data = await WEBApi.login(email, password);
      localStorage.setItem('webToken', data.token);
      // setMessage('Login successful!');
      navigate('/breathe-ev-admin');
      setIsLoading(false);
    } catch (error) {
      setMessage('Login failed. Please check your credentials.');
      setIsLoading(false);
      console.error(error);
    }
  };


  return (
    <div className={styles.container}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <div className={styles.logo}>BE</div>
        <h2 className={styles.title}>Welcome</h2>


        <div className={styles.inputGroup}>
          <input
            type="email"
            className={styles.input}
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <input
            type={showPassword ? 'text' : 'password'}
            className={styles.input}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span
            className={styles.passwordToggle}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <IoEyeOff /> : <IoEyeSharp />}
          </span>
        </div>

        <button disabled={isLoading} type="submit" className={styles.button}>
          {isLoading ? <>
            <div className={`spinner-border ${styles.spinner}`} role="status">
              <span className="sr-only"></span>
            </div>
            Login..
          </> :
            <>
              Login
            </>
          }

        </button>

        {message && (
          <div className={`${styles.message} ${message.includes('successful') ? styles.success : styles.error}`}>
            {message}
          </div>
        )}


      </form>
    </div>
  );
};

export default Login;
